import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Output, Input } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { UploadDocumentService } from '../../../../../_services/upload-document.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-update-confirm-file-modal',
  templateUrl: './update-confirm-file-modal.component.html',
  styleUrls: ['./update-confirm-file-modal.component.scss'],
})
export class UpdateConfirmFileModalComponent{
  @Input() uploadedFile: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  uploadingFiles: ModalOptions;
  hideModal: boolean;
  hideModalOnRoute: any = false;
  incorrectFileFormat: boolean;
  problemUploadingFile: boolean;
  isAcmic = false;
  constructor(
    private uds: UploadDocumentService,
    private acmicService: AcmicService
  ) {
    this.hideModal = false;
    this.incorrectFileFormat = false;
    this.problemUploadingFile = false;
    this.isAcmic = this.acmicService.isACMIC();
    this.uploadingFiles = new ModalOptions({
      additionalClasses:
        'modal-medium modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'updateConfirmFileModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: this.isAcmic ? 'Please confirm' : '',
      modalName: 'update_confirm_files',
    });
  }

  resetHideModal(event): void {
    if (event) {
      this.closeModal.emit(true);
    }
  }
  onClickStay() {
    this.resetHideModal(true);
  }
  onClickExit() {
    this.resetHideModal(true);
    this.uds.setPageExitConfirm(true);
  }
}
